<template>
  <div class="rounded-4 py-1.5 px-2" :class="color">
    <svg role="presentation" focusable="false" tabindex="-1" v-if="type === 'info'"
      class="icon icon-sm mr-1.5"
       
      alt=""
      svg-inline
     xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" fill="none">
<path fill="currentColor" fill-rule="evenodd" d="M6 11.25A5.25 5.25 0 1 0 6 .75a5.25 5.25 0 0 0 0 10.5ZM6 12A6 6 0 1 0 6 0a6 6 0 0 0 0 12Z" clip-rule="evenodd"/>
<path fill="currentColor" d="M5.14 6a.86.86 0 0 1 1.72 0v2.57a.86.86 0 0 1-1.72 0V6ZM5.14 3.43a.86.86 0 1 1 1.72 0 .86.86 0 0 1-1.72 0Z"/>
</svg>
    <svg role="presentation" focusable="false" tabindex="-1" v-else-if="type === 'caution'"
      class="icon icon-sm mr-1.5"
       
      alt=""
      svg-inline
     xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32">
<path fill="currentColor" fill-rule="evenodd" clip-rule="evenodd" d="M16 30a14 14 0 1 0 0-28 14 14 0 0 0 0 28Zm16-14a16 16 0 1 1-32 0 16 16 0 0 1 32 0Z"/>
<path fill="currentColor" fill-rule="evenodd" clip-rule="evenodd" d="M16 4.27a2.87 2.87 0 0 1 2.85 3.18L17.73 17.7a1.7 1.7 0 0 1-3.37 0L13.17 7.45A2.85 2.85 0 0 1 16 4.27Z"/>
<path fill="currentColor" d="M16 26.67a2.13 2.13 0 1 0 0-4.27 2.13 2.13 0 0 0 0 4.27Z"/>
</svg>
    <svg role="presentation" focusable="false" tabindex="-1" v-else-if="type === 'warning'"
      class="icon icon-sm mr-1.5 text-red-900"
       
      alt=""
      svg-inline
     fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
  <path fill="currentColor" d="M16 32a16 16 0 1 0 0-32 16 16 0 0 0 0 32Z"/>
  <path fill="#fff" fill-rule="evenodd" clip-rule="evenodd" d="M16 4.3a2.9 2.9 0 0 1 2.9 3.1l-1.2 10.3c0 .9-.8 1.5-1.6 1.5-1 0-1.6-.6-1.7-1.5L13.2 7.4A2.8 2.8 0 0 1 16 4.3Z"/>
  <path fill="#fff" d="M16 26.7a2.1 2.1 0 1 0 0-4.3 2.1 2.1 0 0 0 0 4.3Z"/>
</svg>
    <svg role="presentation" focusable="false" tabindex="-1" v-else-if="type === 'good'"
      class="icon icon-sm mr-1.5"
       
      alt=""
      svg-inline
     xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32">
<path fill="currentColor" fill-rule="evenodd" d="m11.33 24-5-6.67a1.66 1.66 0 1 1 2.67-2l3.77 5.03 10.3-11.79a1.67 1.67 0 1 1 2.52 2.2L13.92 24.1c-.7.8-1.95.75-2.59-.1" clip-rule="evenodd"/>
</svg>
    <svg role="presentation" focusable="false" tabindex="-1" v-else-if="type === 'promo'"
      class="icon icon-sm mr-1.5"
       
      alt=""
      svg-inline
     xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32">
<path fill="currentColor" fill-rule="evenodd" clip-rule="evenodd" d="m2.18 7.6 1.95 9.83 18.75 10.83 7.54-13.05L11.66 4.38 2.18 7.61Zm10.84 6.3a3.3 3.3 0 1 0-5.7-3.3 3.3 3.3 0 0 0 5.7 3.3Z"/>
<path fill="#fff" d="M19.58 19.41a1.82 1.82 0 0 1 1.83-.91 1.79 1.79 0 0 1 1.26.72c.15.2.25.41.3.65.07.23.1.46.06.7a1.79 1.79 0 0 1-.72 1.26 1.85 1.85 0 0 1-2.05.13 1.9 1.9 0 0 1-.56-.5 2.1 2.1 0 0 1-.31-.63 2.1 2.1 0 0 1-.06-.71c.04-.25.12-.48.25-.7Zm2.39 1.38a.87.87 0 0 0 .1-.68.87.87 0 0 0-.43-.54.87.87 0 0 0-.69-.1.87.87 0 0 0-.54.42.87.87 0 0 0-.1.69c.07.24.2.42.43.54.22.13.45.16.68.1.24-.06.42-.2.55-.43Zm-4.73-6.88a1.82 1.82 0 0 1 1.83-.92 1.79 1.79 0 0 1 1.26.73c.15.2.25.4.3.64.08.23.1.47.06.7a1.79 1.79 0 0 1-.72 1.26 1.85 1.85 0 0 1-2.05.13 1.9 1.9 0 0 1-.56-.49 2.1 2.1 0 0 1-.31-.64 2.1 2.1 0 0 1-.06-.71c.04-.24.12-.48.25-.7Zm2.39 1.38a.87.87 0 0 0 .1-.69.87.87 0 0 0-.43-.54.87.87 0 0 0-.69-.1.87.87 0 0 0-.54.43.87.87 0 0 0-.1.68c.07.24.2.42.43.55.22.12.45.15.68.1.24-.07.42-.21.55-.43Zm3.76-.21.52.74-7.27 4.28-.53-.75 7.28-4.27Z"/>
</svg>
    <slot />
  </div>
</template>

<script lang="ts" setup>
import type { LabelType } from './types'

const props = defineProps<{ type: LabelType }>()

const color = computed(() => {
  switch (props.type) {
    case 'info':
      return 'bg-gray-100 text-gray-900 border-gray-900'
    case 'caution':
      return 'bg-amber-50 text-amber-900 border-amber-900'
    case 'warning':
      return 'bg-red-50 text-gray-900 border-red-900'
    case 'good':
      return 'bg-green-50 text-green-900 border-green-900'
    case 'promo':
      return 'bg-blue-50 text-blue-900 border-blue-900'
    default:
      return ''
  }
})
</script>
